import { NgModule } from "@angular/core";
import { AppModule } from "../ui/app/app.module";
import { OfferCommonModule } from "../offer/common/offer-common.module";
import { PromoCodeComponent } from "./promo-code/promo-code.component";

@NgModule({
  imports: [
    AppModule,
    OfferCommonModule
  ],
  declarations: [PromoCodeComponent],
  exports: [PromoCodeComponent]
})
export class PromotionModule {
}
